module.exports = __webpack_public_path__ + "static/media/S (167).e2434111.jpg";